export const preloadImage = (imageSrc: string) =>
  new Promise((resolve, reject) => {
    const image = new Image()

    image.onload = resolve
    image.onerror = reject
    image.src = imageSrc
  })
